

// Preprod shares prod's backend (gateway, subscription keys, secrets — see k8s_yaml/preprod/config.yaml,
// which is nearly identical to k8s_yaml/prod/config.yaml). Only the app-facing domain differs, so this
// file mirrors environment.prod.ts and swaps just the preprod frontend host.
export const environment: any = {
	production: true,
	rpdIdNsdl:"362",
	rpdIdCdsl:"363",
	diyJouneryBaseUrl:'https://register.iiflcapital.com/onboarding-dashboard/login?token=',
	gatewayBaseUrl: "https://dataservice.iiflcapital.com/",
	// TODO: confirm prod invest host with backend team before release — placeholder mirrors the UAT domain pattern
	investBaseUrl: "https://invest.iiflcapital.com/",
	aaaGroBox : "aaa/api/Grobox/",
	//aaa
    aaaBase: "aaa/api/AAA/",
    aaa360: "aaa/api/Client360/",
    aaaBackOffice: "aaa/api/BackOffice/",
	aaaSearch: "aaa/",
	aaaDashboard: "AAA/api/Dashboard/",
	aaaTerminal: "aaa/api/terminal/",
	aaaReport: 'aaa/api/Report/',
	aaaRevenueSimulation:'aaa/api/RevenueSimulation/',
	nodeUrl:'users/download-pdf',
	aaaJV : 'aaa/api/JV/',
	//mf
	mfApp: "MFApp/",
    //ipo
	ipo: "ipo/",
    //zoho (iiflcrm)
	//crmId:'ED349A8E0DEA4512',  //not in use
	iiflCRM2:'https://crm.iifl.in/',
	createTokenCRM2:'ZohoCRMAPI/api/ZohoCRMWebAPI/',
    iiflCRMWebAPI2: "ZohoCRMAPI/api/ZohoCRMWebAPI/",
	iiflCRM: "iiflcrm/",
    iiflCRMWebAPI: "iiflcrm/ZohoCRMAPI/api/ZohoCRMWebAPI/",
	iiflCRMFunctions: "iiflcrm/crm/v2/functions/",
	iiflCRMKbArticles: "iiflcrm/portal/api/kbArticles/",
    //tt
	ttNewUserActivity: "tt/UserActivity/",
	ttNewOrderbook: "tt/TradingRelatedAPI/",
	ttNewNotification: "tt/Notification/",
	ttUserActivity: "tt/TT/Broking/UserActivity/",
	ttTrading: "tt/TT/Broking/TradingRelatedAPI/",
	ttClient: "tt/TT/Broking/Client/",
	ttClient1:"tt/Client",
	ttScrip: "tt/TT/Broking/Scrip/",
	ttCompanyInfo: "tt/TT/Broking/CompanyInfo/",
	ttStockDetail: "tt/TT/Broking/StockDetail/",
	ttDataInfo: "tt/TT/Broking/DataInfo/",
	ttFundTransfer: "tt/TT/Broking/FundTransfer/",
	ttAppBo: "tt/Mob/Service1.svc/",
	ttAppBoV1:'tt/TT/Broking/SpanCalculation/',
	ttAppBoV2:'tt/SpanCalculation/',
	ttMarket: "tt/TT/Broking/MarketWatch/",
	Offmarket: 'aaa/api/Offmarket/',
	//papi
	papiDerivative: "papi/IIFL/Derivative/Derivative.svc/",
	papiMarket: "papi/IIFL/Equity/market.svc/",
	papiMobileAPI: "papi/IIFL/mobileapi/mobapi.svc/",
	// subscription Key
	// Values below are process.env key NAMES resolved server-side (see server.ts),
	// not real secrets — do not put actual credential values here.
	gatewaySubscriptionKey: {
		aaa: "AAA_OCP",
		tt: "TT_OCP",
		iiflcrm: "iiflcrm_OCP",
		eaccount: "eaccount",
		extentedapi: "extentedapi"
	},
	ipAdress: 'https://dataservice.iiflcapital.com/aaa/api/AAA/IPAddress',
	errorLog: 'aaa-angular-app',
	apiUrl: 'https://swaraj.iiflcapital.com/',
	baseUrl: 'https://dataservice.iifl.in/aaa/prod/',
	tradeStURL:'https://swaraj.iiflcapital.com/MFAPP/Service1.svc/',
	forgotPasswordURL: 'https://attendance.indiainfoline.com/OTPGeneration/frmOTPGeneration.aspx',
	newsinfoUrl: 'https://api.indiainfoline.com/',
	oneUrl: 'https://aaapreprod.iiflcapital.com/',
	apiProxyBaseUrl: 'https://aaa.iiflcapital.com',
	oneLoginUrl: 'https://iifl.onelogin.com/oidc/2',
	oneLoginKey: '343c66c0-042d-013c-9294-4e2b35e631b538188',
	boAppName: 'AAAWEB',
	appNameValue:'AAA',
	app_version:1,
	mobile_app_version: '3.0.3',
	gstInvoiceRptId:'239',
	autoDebitRptId : '113',
	oneLoginOidc:'https://iifl.onelogin.com/',
	imageBranding:{
		url: 'https://iifl.anchoredgetechno.com/Home/AAALogin'
	},

	nativeHeaders: {
		'Content-Type': 'application/json',
		'clientID':  (typeof window !== 'undefined' && window.localStorage?.getItem('userID'))
  ? window.localStorage.getItem('userID')
  : 'NA',
		'Pragma': 'no-cache',
		'Cache-Control': 'no-cache',
		'withCredentials': 'true',
	},
	// date formate MM/DD/YYYY
	showNewIcon : [
		  {date: new Date('09/11/2024'), reportName:'AUM Report'},
	      {date : new Date('10/24/2024'), reportName : 'Online SIP Report'},
		  {date : new Date('10/09/2024'), reportName : 'DIS Book Issuance Status'},
	      {date: new Date('10/02/2025'), reportName:'Auto Debit DP Bill Report'}
	  ],
	firebaseConfig  : {
			apiKey: "AIzaSyAiPvs2UamDLxwH2dpfZOfMd6c-nHywFKU",
			authDomain: "aaa-project-477207.firebaseapp.com",
			projectId: "aaa-project-477207",
			storageBucket: "aaa-project-477207.firebasestorage.app",
			messagingSenderId: "1054580133683",
			appId: "1:1054580133683:web:e6df3d5409d994f03c7846",
			measurementId: "G-XE8HZXG012"
		 },
};

export const ChartLink: any = {
	Chart : {
		basic: 'https://charts.iiflsecurities.com/TV_Sw/basic-tv.html?type=future-curcom&period=1&range=d&exchange=',
		advanced:'https://charts.iiflsecurities.com/TV_Sw/index.html?type=future-curcom&period=1&range=d&exchange=',
		detailIndChart:'https://charts.iiflsecurities.com/TV_Sw/basic-tv.html?type=overview&period=1&exchange='
	},
}

// exchange msg button click on notification center
export const notification: any = {
	notificationLink : {
		link: 'https://ttweb.iiflcapital.com/Trade/ExchangeMessages.aspx?App=0',
	}
}


/* FOR INVEST SCREEN  */
export const investObj: any = {
	fdURL : {
		shriram: 'https://cos.stfc.in/cos/affiliate/cos_schemedetails.aspx',
		icici: 'https://www.icicihfc.com/fixed-deposit/fd-online-application-form/broker-details.html',
		bajaj: 'https://cont-sites.bajajfinserv.in/fixed-deposit-application-form'
	},
	bondURL: {
		irfc: 'https://kosmic.kfintech.com/IRFC/Brokers/default.aspx?k=A354A4',
		recBond: 'https://kosmic.kfintech.com/REC/brokers/default.aspx?k=C9AED7',
		pfcBond: 'https://kosmic.kfintech.com/PFC/Brokers/default.aspx?k=B6ACC6'
	},
	loans: {
		businessLoan: 'https://www.iifl.com/securities/business-partners/aaa/business-loan/',
		personalLoan: 'https://www.iifl.com/securities/business-partners/aaa/personal-loan/', /* LIVE URL */
		homeLoan: 'https://www.iifl.com/securities/business-partners/aaa/home-loan/' /* LIVE URL */
	},
	addUser: {
		getTokenURL: 'https://dataservice.iiflcapital.com/refernearn/TokenGenerateForCOBD',
		addClientURL: 'https://eaccount.indiainfoline.com/Dashboard/RMDashboard_V1',
		addSubbrokerURL: 'https://subbroker-franchisee.iifl.com/Dashboard/RMDashboard_V1',
		addNRI: 'https://nri-eaccount.indiainfoline.com/login',
		addICA: 'https://fankyc.iifl.in/Login/RMDashboard_V1',
		addICABanca : 'https://bancakyc.iifl.in/'
	},
	fp360 : {
		url: 'https://fp360.iifl.com/ClientPortal/UI/SSOFPLogin',
	},
	smallCase : {
		apiURL: 'https://dataservice.iiflcapital.com/aaa/smallcase/Home/GetAuthorize',
		redirectURL: 'https://smallcases.indiainfoline.com/brokerLogin?params=agent%3Ddealer_2'
	},
	narnolia: {
		url: 'https://dataservice.iiflcapital.com/tt/TT/Broking/UserActivity/GenerateSessionIdForTTWeb'
	},
	nps:{
		url:'https://cra.kfintech.com/poponline/POPAuthenticate'
	},
	goldenPi: {
		url: 'https://dealers.goldenpi.com',
	},
	narnoliaRealTimeMap: {
		url: 'https://dataservice.iiflcapital.com/tt/TT/Broking/Client/InsertClientCodeAppSourceMob',	// review. UAT URL
	},
	offlineIPO : {
		url: 'https://ipo.iifl.in/IILIPO/offlineIPOentry.aspx',
	},
	onlineIPO : {
		apiURL: 'https://portfolio.iiflcapital.com/ipocookie/api/Home/GetAuthorize',
		url: 'https://reports.iiflcapital.com/Myaccount/IPO.aspx',
		domain: '.indiainfoline.com'
	},
	offlineNCD : {
		url: 'https://ipo.iifl.in/IILIPO/offlineBONDentry.aspx',
		domain: '.iifl.in'
	},
	downloadNCD : {
		url: 'https://ipo.iifl.in/NCDForm/'
	},
	financialHealth : {
		url: 'https://financialhealth.iifl.com?business=securities&utm_source=iiflmarketsapp',
	},
	mutualFund: {
		url: 'https://mf.indiainfoline.com/MFOnline/Login/MFDeeplink',
	},
	insurance: {
		url: 'https://iiflinsurance.com',
		partnerCode: 'IFAAA'
	},
	goalCalculator:{
		url: 'https://mf.indiainfoline.com/MFOnline/Goal',
	},
	iiflBuzz:{
		url: 'https://www.indiainfoline.com/buzz-web'
	}
}

export const researchReport: any = {
	morningMantra: {
		url: 'https://content.iiflcapital.com/_media/iifl/img/research_reports/pdf/morning-note.pdf'
	}
}
export const guestLogin: any = {
	optimum: {
		url: 'https://epartner.iifl.com/Referral'
	}
}
